import { connect } from 'react-redux';
import {
    VARIANT_ON,
    PINATA_MFA_AUTH,
} from '@zocdoc-frontend-common/utils-ab/constants';
import { wrapWithDispatch } from '@zocdoc-frontend-common/utils-react';
import {
    clickRememberMe,
    enterEmail,
    enterPassword,
    signInFetch,
    signInAndGetUser,
    signInFormTrackingActionCreators,
    signInFetchMFAOn,
} from './signInFormActions';
import { SignInFormView } from './SignInFormView';

export const mapStateToProps = (state) => {
    if (state.signInForm === undefined) {
        throw new Error(
            'Expected the sign in state to be available as `state.signInForm`. ' +
                "Ensure you have added the `signInReducer` to your store's reducers via `combineReducers`."
        );
    }

    return {
        email: state.signInForm.email,
        password: state.signInForm.password,
        passwordExpired: state.signInForm.passwordExpired,
        rememberMe: state.signInForm.rememberMe,
        signingIn: state.signInForm.signingIn,
        signedIn: state.signInForm.signedIn,
        signInError: state.signInForm.signInError,
        validationError: state.signInForm.validationError,
        isInMfaLoginExperiment:
            state.absystem?.[PINATA_MFA_AUTH.experimentId] === VARIANT_ON,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    onChangeEmailInput: (email) => {
        dispatch(enterEmail(email));
    },
    onChangePasswordInput: (password) => {
        dispatch(enterPassword(password));
    },
    onChangeRememberMeCheckbox: (rememberMe) => {
        dispatch(signInFormTrackingActionCreators.trackRememberMeChange());
        dispatch(clickRememberMe(rememberMe));
    },
    onSubmitSignIn: (email, password, rememberMe) => {
        dispatch(signInFormTrackingActionCreators.trackClickContinue());
        dispatch(signInFetch(email, password, rememberMe));
    },
    onSubmitSignInWithUserFetch: (email, password, rememberMe) => {
        dispatch(signInFormTrackingActionCreators.trackClickContinue());
        dispatch(signInAndGetUser(email, password, rememberMe));
    },
    onSubmitSignInWithMFA: (email, password) => {
        dispatch(signInFetchMFAOn(email, password));
    },
    ...wrapWithDispatch(signInFormTrackingActionCreators, dispatch),
});

export const SignInFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignInFormView);
